import { render, staticRenderFns } from "./PopUpAsignFile.vue?vue&type=template&id=146242b4&scoped=true&"
import script from "./PopUpAsignFile.vue?vue&type=script&lang=js&"
export * from "./PopUpAsignFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146242b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('146242b4')) {
      api.createRecord('146242b4', component.options)
    } else {
      api.reload('146242b4', component.options)
    }
    module.hot.accept("./PopUpAsignFile.vue?vue&type=template&id=146242b4&scoped=true&", function () {
      api.rerender('146242b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/vistas/modals/PopUpAsignFile.vue"
export default component.exports